import { Configuration } from "./Configuration";

export type Router = {
  isFeatureEnabled: (feature: keyof Configuration) => boolean;
};

export function createFeatureRouter(configuration: Configuration): Router {
  return {
    isFeatureEnabled(feature: keyof Configuration): boolean {
      return configuration[feature];
    },
  };
}
